declare const history: any;
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Player } from 'src/models/player.model';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScores } from 'src/models/myscores.model';
import { UserService } from 'src/services/user.service';
import { map } from 'rxjs/operators';
import { ProfileService } from '../profile/profile.service';

@Component({
  selector: 'avatar-big',
  templateUrl: './avatarbig.component.html',
  styleUrls: ['avatarbig.component.scss']
})
export class AvatarBigComponent implements OnInit {
  public avatar?: string;
  public fullName?: string;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private profileSvc: ProfileService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const playerId = params['playerId'];
      this.http.get<any>(`/api/playerapi/${playerId}`)
        .subscribe(
          (resp) => {
            this.fullName = resp.fullName;
          }
        )
      this.profileSvc.getAvatar(playerId).subscribe(
        (resp) => this.avatar = resp.base64img,
        (err) => console.log('no avatar found')
      );

    });
  }
  back(evt: any): void {
    evt.preventDefault();
    history.back();
  }
}
